import { ChangeDetectionStrategy, Component, input, InputSignal } from '@angular/core';

@Component({
  selector: 'sz-section-head',
  templateUrl: './sz-section-head.component.html',
  styleUrls: ['./sz-section-head.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true
})
export class SzSectionHeadComponent {
  readonly label: InputSignal<string> = input.required<string>();
  readonly count: InputSignal<number | string | null> = input<number | string | null>(null);
}
